/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {initiateExternalTransactionReversal} from '../api'

export const useMutationInitiateExternalTransactionReversal = createReactQueryMutationHook('initiateExternalTransactionReversal', initiateExternalTransactionReversal)
